import { render, staticRenderFns } from "./RegistrationApply.vue?vue&type=template&id=285dcd17&scoped=true&"
import script from "./RegistrationApply.vue?vue&type=script&lang=js&"
export * from "./RegistrationApply.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationApply.vue?vue&type=style&index=0&id=285dcd17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285dcd17",
  null
  
)

export default component.exports